const Goals = [
  "find & join a community",
  "learn a tech skill",
  "create/host my community",
  "get a job/internship",
  "Others",
];

export default Goals;
